import { Controller, IDynamicLoader, Loader, Toolbar, skipWithDefault } from '@tencent/workbench';
import { TOOLBAR_ITEMS, config } from './config';
import { IAnimCornerMarkFeature } from './anim-corner-mark-interface';
import * as React from 'react';

/**
 * 将类CornerMarkController标记为控制器 将TOOLBAR_ITEMS作为工具栏项
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class CornerMarkController {
    /**
     * 使用loader装饰器注入一个IAnimCornerMarkFeature类型的加载器
     * IDynamicLoader<IAnimCornerMarkFeature> 表示loader是一个动态加载器
     */
    public constructor(@Loader(IAnimCornerMarkFeature) private loader: IDynamicLoader<IAnimCornerMarkFeature>) {}

    /**
     * 获取loader加载器实例化的IAnimCornerMarkFeature类型的对象
     */
    private get feature() {
        return this.loader.instance;
    }

    @Toolbar(config.id, 'onClick')
    public handleSwitch() {
        this.feature?.handleSwitch();
    }

    @Toolbar(config.id, 'content')
    @skipWithDefault(<></>)
    public animCornerMarkContent() {
        return this.feature?.getContent() ?? <></>;
    }

    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisabled() {
        return this.feature?.shouldDisabled() ?? false;
    }
}
